export { HistoryTable } from './HistoryTable.tsx';
